import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import classNames from 'classnames';
import { Icon } from '@massds/mayflower-react';
import { isInternalLink } from '../../utils/nav';
import './index.scss';

const GatsbyLink = ({
  children, to, type, ...other
}) => {
  // This example assumes that any internal link (intended for Gatsby)
  // will start with exactly one slash, and that anything else is external.
  const internal = isInternalLink(to);

  const linkClasses = classNames({
    ma__link: true,
    'ma__decorative-link': type === 'decorative'
  });

  // Use Gatsby Link for internal links, and <a> for others
  if (internal) {
    return(
      <span className={linkClasses}>
        <Link to={to} {...other}>
          {children}
          {type === 'decorative' && (
          <React.Fragment>
            <span>&nbsp;</span>
            <Icon name="arrow" aria-hidden="true" />
          </React.Fragment>
          )}
        </Link>
      </span>
    );
  }
  return(
    <span className={linkClasses}>
      <a href={to} className={linkClasses} {...other}>
        {children}
        {type === 'decorative' && (
        <React.Fragment>
          <span>&nbsp;</span>
          <Icon name="arrow" aria-hidden="true" />
        </React.Fragment>
        )}
      </a>
    </span>
  );
};

GatsbyLink.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  type: PropTypes.oneOf(['', 'decorative'])
};

GatsbyLink.defaultProps = {
  type: ''
};

export default GatsbyLink;
